export enum dialogServiceIconClasses {
  success = 'fa fa-check-circle',
  failed = 'fa fa-times-circle',
}
